function ModalButton({ text, onClick }) {
	return (
		<button className="w-full rounded-full border-[3px] border-[#DDDDDD] bg-black p-3 text-white" onClick={onClick}>
			{text}
		</button>
	);
}

export default ModalButton;
